import { FC, useCallback, useState } from "react";
import { Control, useController } from "react-hook-form";

import SelectionRadioGroup, { SelectionRadioGroupProps } from "./SelectionRadioGroup.tsx";

export type ControlledSelectionRadioGroupProps = Omit<
  SelectionRadioGroupProps,
  "value" | "onChange"
> & {
  control: Control<any>;
};

const ControlledSelectionRadioGroup: FC<ControlledSelectionRadioGroupProps> = ({
  control,
  name,
  ...props
}) => {
  const { field } = useController({
    control,
    name,
  });
  const [value, setValue] = useState<string>(field.value);

  const onSingleChange = useCallback(
    (newValue: string) => {
      setValue(newValue);
      field.onChange(newValue);
    },
    [field],
  );

  return <SelectionRadioGroup name={name} value={value} onChange={onSingleChange} {...props} />;
};

export default ControlledSelectionRadioGroup;
